import { Component, OnInit, ViewChild } from '@angular/core';
import { RouterLink, RouterOutlet } from '@angular/router';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatMenuModule } from '@angular/material/menu';
import { MatButtonModule } from '@angular/material/button';
import { MatSidenav, MatSidenavModule } from '@angular/material/sidenav';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatDividerModule } from '@angular/material/divider';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { SidebarService } from './sidebar.service';
import { APIService } from '../fleet-management/backend-service/backend-service';
import { GlobalVariablesService } from '../global.service';
import { environment } from '../../environments/environment';
import { SettingService } from '../settings/setting-service';

@Component({
  selector: 'app-home',
  standalone: true,
  imports: [
    MatToolbarModule,
    MatMenuModule,
    MatButtonModule,
    MatSidenavModule,
    MatIconModule,
    MatListModule,
    MatExpansionModule,
    MatDividerModule,
    MatProgressSpinnerModule,
    CommonModule,
    RouterOutlet
  ],
  templateUrl: './home.component.html',
  styleUrl: './home.component.scss'
})
export class HomeComponent implements OnInit {
  @ViewChild('sidenav') sidenav!: MatSidenav;
  title = 'Fleet Management';
  opened = true;
  link: string = '/home/dashboard';
  selectedItem: number | null = 0;

  private readonly navRoots = [
    '/home/user-management',
    '/home/customer-management',
    '/home/consignee-registration',
    '/home/shipping-order/order-tracking',
    '/home/booking-list',
    '/home/truck-profile',
    '/home/driver-profile',
    '/home/transport-management',
    '/home/report',
    '/home/accounting',
    '/home/settings/user-settings',
    '/home/settings/truck-settings',
    '/home/settings/customer-settings',
    '/home/settings/report-predefind-data',
    '/home/dashboard',
  ];
  userName = "User_Name";
  profilePicture = "";
  email = "email@example.com";
  datas: any[] = [];
  isLoading: boolean = false;

  notifications = [
    {
      title: "Assign Truck",
      content: "A goods has been assign to your truck, Ref:#20348947",
      time: '19-03-2025 11:52 AM',
    },
    {
      title: "User Activation",
      content: "Your user has been activated by Mr. Sok Chea",
      time: '21-03-2025 09:36 AM',
    },
    {
      title: "User Activation",
      content: "Your user has been activated by Mr. Sok Chea",
      time: '21-03-2025 09:36 AM',
    },
  ]


  constructor(private router: Router, public sidebarService: SidebarService, private apiService: APIService, private globalVariable: GlobalVariablesService) {
  }
  ngOnInit(): void {

    this.opened = true;
    const currentUrl = this.router.url.split('?')[0];
    const matched = this.navRoots.find(root => currentUrl.startsWith(root));
    this.link = matched ?? '/home/dashboard';
    if (currentUrl === '/home' || currentUrl === '/home/') {
      this.router.navigate(['/home/dashboard'], { replaceUrl: true });
    }
    // this.navigateToComponent('/home/settings/customer-settings')
    let userProfile = JSON.parse(localStorage.getItem('userProfile')!)
    let loginData = JSON.parse(localStorage.getItem('loginData')!)
    const profile = userProfile?.data || userProfile
    console.log("User_Profile_Cache: ", profile)
    this.userName = profile?.englishName || profile?.username || loginData?.user?.username || 'User'
    this.email = profile?.email || loginData?.user?.email || ''
    this.profilePicture = profile?.profilePicture ? environment.imageUrl + profile.profilePicture : 'assets/images/default-profile.png'
    this.getSetting();
    this.getRolesOptions();

    console.log("API ENV: ", environment.imageUrl)

  }
  onEditProfile() {

  }

  getRolesOptions() {
    let loginData = JSON.parse(localStorage.getItem('loginData')!)
    this.apiService.get('/api/roles/options', loginData.token).subscribe({
      next: (response) => {
        console.log('/api/roles/options' + ',\n' + 'Roles_Response:', response.body);
        if (response.status === 200 && response.body?.data) {
          this.globalVariable.SETTING_USER_ROLES = response.body.data;
        }
      },
      error: (error) => {
        console.error('Error fetching roles:', error.message);
      }
    });
  }

  getSetting() {
    this.datas = [];
    this.isLoading = true;
    let loginData = JSON.parse(localStorage.getItem('loginData')!)
    this.apiService.get('/api/predefined-data/groups', loginData.token).subscribe({
      next: (response) => {
        console.log('/api/predefined-data/groups' + ',\n' + 'Setting_Response:', response.body);
        if (response.status === 200) {
          try {
            this.datas = response.body;
            if (this.datas.length > 0) {
              this.globalVariable.SETTING_CREDIT_TERMS = this.datas.filter((item: any) => item.name === 'CREDIT_TERMS')[0].data;
              this.globalVariable.SETTING_BUSINESS_TYPES = this.datas.filter((item: any) => item.name === 'BUSINESS_TYPES')[0].data;
              this.globalVariable.SETTING_FINANCIAL_RATINGS = this.datas.filter((item: any) => item.name === 'FINANCIAL_RATINGS')[0].data;
              this.globalVariable.SETTING_TRUCK_TYPES = this.datas.filter((item: any) => item.name === 'TRUCK_TYPES')[0].data;
              this.globalVariable.SETTING_TRUCK_MODEL_NUMBERS = this.datas.filter((item: any) => item.name === 'TRUCK_MODEL_NUMBERS')[0].data;
              this.globalVariable.SETTING_TRUCK_LOADING_CAPACITY = this.datas.filter((item: any) => item.name === 'TRUCK_LOADING_CAPACITY')[0].data;
              this.globalVariable.SETTING_BOX_SIZE = this.datas.filter((item: any) => item.name === 'BOX_SIZE')[0].data;
              this.globalVariable.SETTING_BOX_LOADING_TYPES = this.datas.filter((item: any) => item.name === 'BOX_LOADING_TYPES')[0].data;
              this.globalVariable.SETTING_VEHICLE_MAINTENANCE = this.datas.filter((item: any) => item.name === 'VEHICLE_MAINTENANCE')[0].data;
              this.globalVariable.SETTING_INCIDENT_REPORT = this.datas.filter((item: any) => item.name === 'INCIDENT_REPORT')[0].data;
              this.globalVariable.SETTING_ROUTE_EXPERTISE = this.datas.filter((item: any) => item.name === 'ROUTE_EXPERTISE')[0].data;
              this.globalVariable.SETTING_INSURANCE_TYPES = this.datas.filter((item: any) => item.name === 'INSURANCE_TYPES')[0].data;
              this.globalVariable.SETTING_SECURITY_DEPOSIT_AMOUNT = this.datas.filter((item: any) => item.name === 'SECURITY_DEPOSIT_AMOUNT')[0].data;
              this.globalVariable.SETTING_QUANTITY_TYPES = this.datas.filter((item: any) => item.name === 'QUANTITY_TYPES')[0].data;
              this.globalVariable.SETTING_HANDLING_METHODS = this.datas.filter((item: any) => item.name === 'HANDLING_METHODS')[0].data;
              this.globalVariable.SETTING_DIMENSION = this.datas.filter((item: any) => item.name === 'DIMENSION')[0].data;
              this.globalVariable.ORDER_BOOKING_STATUS = this.datas.filter((item: any) => item.name === 'ORDER_BOOKING_STATUS')[0].data;
              this.globalVariable.YEAR_MADE = this.datas.filter((item: any) => item.name === 'YEAR_MADE')[0].data;
              this.globalVariable.TRUCK_STATUS = this.datas.filter((item: any) => item.name === 'TRUCK_STATUS')[0].data;
              this.globalVariable.TRACKING_STATUS = this.datas.filter((item: any) => item.name === 'TRACKING_STATUS')[0].data;
              this.globalVariable.PACKAGING_TYPES = this.datas.filter((item: any) => item.name === 'PACKAGING_TYPES')[0].data;
              this.globalVariable.TEMPERATURE_CONTROL = this.datas.filter((item: any) => item.name === 'TEMPERATURE_CONTROL')[0].data;
              this.globalVariable.HANDLING_TYPES = this.datas.filter((item: any) => item.name === 'HANDLING_TYPES')[0].data;
              console.log("SETTING_USER_ROLES: ", this.globalVariable.SETTING_USER_ROLES)
              console.log("SETTING_CREDIT_TERMS: ", this.globalVariable.SETTING_CREDIT_TERMS)
              console.log("SETTING_BUSINESS_TYPES: ", this.globalVariable.SETTING_BUSINESS_TYPES)
              console.log("SETTING_FINANCIAL_RATINGS: ", this.globalVariable.SETTING_FINANCIAL_RATINGS)
              console.log("SETTING_TRUCK_TYPES: ", this.globalVariable.SETTING_TRUCK_TYPES)
              console.log("SETTING_TRUCK_MODEL_NUMBERS: ", this.globalVariable.SETTING_TRUCK_MODEL_NUMBERS)
              console.log("SETTING_TRUCK_LOADING_CAPACITY: ", this.globalVariable.SETTING_TRUCK_LOADING_CAPACITY)
              console.log("SETTING_BOX_SIZE: ", this.globalVariable.SETTING_BOX_SIZE)
              console.log("SETTING_BOX_LOADING_TYPES: ", this.globalVariable.SETTING_BOX_LOADING_TYPES)
              console.log("SETTING_VEHICLE_MAINTENANCE: ", this.globalVariable.SETTING_VEHICLE_MAINTENANCE)
              console.log("SETTING_INCIDENT_REPORT: ", this.globalVariable.SETTING_INCIDENT_REPORT)
              console.log("SETTING_ROUTE_EXPERTISE: ", this.globalVariable.SETTING_ROUTE_EXPERTISE)
              console.log("SETTING_INSURANCE_TYPES: ", this.globalVariable.SETTING_INSURANCE_TYPES)
              console.log("SETTING_SECURITY_DEPOSIT_AMOUNT: ", this.globalVariable.SETTING_SECURITY_DEPOSIT_AMOUNT)
              console.log("SETTING_QUANTITY_TYPES: ", this.globalVariable.SETTING_QUANTITY_TYPES)
              console.log("SETTING_HANDLING_METHODS: ", this.globalVariable.SETTING_HANDLING_METHODS)
              console.log("SETTING_DIMENSION: ", this.globalVariable.SETTING_DIMENSION)
              console.log("ORDER_BOOKING_STATUS: ", this.globalVariable.ORDER_BOOKING_STATUS)
              console.log("YEAR_MADE: ", this.globalVariable.YEAR_MADE)
              console.log("TRACKING_STATUS: ", this.globalVariable.TRACKING_STATUS)
              console.log("PACKAGING_TYPES: ", this.globalVariable.PACKAGING_TYPES)
              console.log("TEMPERATURE_CONTROL: ", this.globalVariable.TEMPERATURE_CONTROL)
              console.log("HANDLING_TYPES: ", this.globalVariable.HANDLING_TYPES)
              console.log("isLoggedIn: ", this.globalVariable.isLoggedIn);
              this.globalVariable.isLoggedIn = true; // Set the login status to true

            }
            else {
              console.log("No Setting Data Found")
            }
          } catch (error) {

          }
        }
        else {
          console.log("Hey you")
        }
        this.isLoading = false;
      },
      error: (error) => {
        console.error('Error status:', error.status);
        console.error('Error message:', error.message);
        this.isLoading = false;
      }
    });
  }



  isActive(route: string): boolean {
    return this.router.url === route;
  }
  navigateToComponent(link: string) {
    if (this.sidebarService.isSmallScreen) {
      this.sidenav.close(); // Only close if it is the mobile phone screen
    }
    this.link = link;
    this.router.navigate([this.link]);
  }
  logout() {
    localStorage.removeItem('loginData');
    localStorage.removeItem('loginExpiry');
    localStorage.removeItem('userProfile');
    this.router.navigateByUrl('/login', { replaceUrl: true }).then(() => {
      history.replaceState(null, '', '/login'); // Clear browser history
      history.pushState(null, '', location.href);
      window.onpopstate = () => {
        history.pushState(null, '', location.href);
      };
    });
  }
}
